import React, { useState, useEffect, useRef, useContext } from 'react'
import axios from 'axios'
import { API_URL } from '../../Constant';
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../assets/Messages.json'
import { useNavigate } from 'react-router-dom';
import {showAppLoading,  generateYearRange, isNumeric, validateButtonASIBlock, getStatusFlagValue } from '../../Custom/Custom';
import BlockIData from '../../assets/BlockIData.json';
import asiTitle from '../../asi.json';
import { BlockEContextData } from '../../context/BlockEContext';

export default function BlockI({
   blockPageInfo,
   config,
   userInfoObject,
   blockInfo,
   accessAsiBlock,
   decode_token,
   blockEfieldData = { wagesOrSalaries: 0 }
}) {

   const { initialData } = useContext(BlockEContextData);
   // console.log('BlockI received blockEfieldData:', blockEfieldData.wagesOrSalaries);
   // console.log('BlockI received from context:', initialData);

   const yearRange = generateYearRange(blockInfo.surveyYear);
   const [itemData, setItemData] = useState({});
   const [originalValues, setOriginalValues] = useState({}); // Add this state to track original values
   const [blockIData, setBlockIData] = useState({});
   const navigate = useNavigate();
   const [buttonStatus, setButtonStatus] = useState('');
   const [statusFlageval, setStatusFlageval] = useState('');
   const roleCodes = decode_token?.id?.ROLE_CODE
      ? String(decode_token.id.ROLE_CODE)
           .split('|')
           .map((r) => String(r).trim())
           .filter(Boolean)
      : [];
   const isDivasiRole = roleCodes.includes('DIVASI');
   const isDivasiStatusFlagOne = isDivasiRole && String(statusFlageval ?? '').trim() === '1';
   const isHqRole = roleCodes.includes('HQADM') || roleCodes.includes('HQASI');
   const isHqStatusFlagThree = isHqRole && String(statusFlageval ?? '').trim() === '3';
  const isRestrictedRoleWithEmptyStatusFlag = (isDivasiRole || isHqRole) && String(statusFlageval ?? '').trim() === '';
  const isNextBlockAlreadyAccessible = (() => {
    const ids = JSON.parse(localStorage.getItem('blockIds') || '[]');
    return Array.isArray(ids) && ids.map(Number).includes(10);
  })();
   const [checkedItems, setCheckedItems] = useState([]);
   const [blockEfieldDataState, setBlockEfieldDataState] = useState({ wagesOrSalaries: 0 });
   const [blockFfieldData, setBlockFfieldData] = useState({ expenditure: 0 });
   const [blockHfieldData, setBlockHfieldData] = useState({ purchaseValue: 0 });
   const [fetchASIFormECallback, setFetchASIFormECallback] = useState({ formEItem14Value: 0 });
   const itableRef = useRef(null);
   let srNo = 0;
   const uuid = require('uuid');
   const itemCodeArray = ['9922100', '9994000'];
   const statusUnitCode = localStorage.getItem('statusUnitCode')

   useEffect(() => {
      blockIDataLoad();
   }, [])

   useEffect(() => {
      // console.log('BlockI - Context data changed:', initialData);
   }, [initialData]);

   const blockIDataLoad = async () => {
      const newObject = {
         dsl_no: blockInfo.dslNo,
         survey_year: blockInfo.surveyYear
      };
      showAppLoading(true)
      try {
         const response = await axios.post(`${API_URL}api/asi/blockIForm`, newObject, config);
         const { data, status } = response.data;
         let responseBlockIData = '';
         let statusFlage = '';
         if (status) {
            responseBlockIData = addFiveEmptyRow(data.blockIData, 'dynamic', 4);//  Database
           statusFlage = responseBlockIData?.[responseBlockIData.length - 1]?.statusFlag ?? '';
         } else {
            responseBlockIData = addFiveEmptyRow(BlockIData, 'static', 4);// static  json Data
            statusFlage = ''
         }
         setStatusFlageval(statusFlage);
     
         setBlockEfieldDataState(data.blockEfieldData || { wagesOrSalaries: 0 })
         setBlockFfieldData(data.blockFfieldData || { expenditure: 0 })
         setBlockHfieldData(data.blockHfieldData || { purchaseValue: 0 })
         setFetchASIFormECallback(data.fetchASIFormECallback || { formEItem14Value: 0 })

         const IsButtonStatus = await validateButtonASIBlock(decode_token, statusFlage);
         customObjectObjectData(responseBlockIData)
         setButtonStatus(IsButtonStatus)
      } catch (error) {
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {
         showAppLoading(false);
      }
   }

   // Function to handle Added 5 empty row on page Load  
   const addFiveEmptyRow = (responseBlockIData, dataType, emptyRowCount) => {
      let customObject = [];
      let mergedArray = '';
      for (let i = 0; i <= emptyRowCount; i++) {
         const newItemAdded = {
            "dslNo": blockInfo.dslNo,
            "surveyYear": blockInfo.surveyYear,
            "itemCode": '',
            "unitOfQty": '',
            "qtyConsumed": '',
            "purchaseValue": '',
            "ratePerUnit": '',
            "itemDesc": '',
            "statusFlag": '',
            "itemCodeClass": "textBox_back_color_white",
         };
         customObject.push(newItemAdded);
      }

      if (dataType === "dynamic") {
         const dataArray = Object.values(responseBlockIData);
         const AddedIndex = dataArray.length - 2
         mergedArray = [
            ...responseBlockIData.slice(0, AddedIndex),
            ...customObject,
            ...responseBlockIData.slice(AddedIndex)
         ];
      } else if (dataType === "static") {
         mergedArray = [
            ...responseBlockIData.slice(0, 0),
            ...customObject,
            ...responseBlockIData.slice(0)
         ];
      }

      return mergedArray;
   };

   /*   reset form data code start here */
   const handleReset = () => {
      const dataArray = Object.values(itemData);
      const initialData = {};
      dataArray.forEach((item, index) => {
         initialData[index] = {
            id: index,
            dslNo: item.dslNo,
            itemCode: item.itemCode,
            itemDesc: item.itemDesc,
            purchaseValue: '',
            qtyConsumed: '',
            ratePerUnit: '',
            unitOfQty: '',
         };
      });
      setItemData(initialData);
   }

   /* reset form data code end here */

   // Function to handle going to the previous block 
   const handlePrevious = () => {
      const confirmed = window.confirm("Have you saved your changes?");
      if (confirmed) {
         //handleSaveData("SAVE")
         navigate("/BlockH")
      }
   }

   // Function to handle going to the next block      
   const handleNext = async () => {
      // Next unlocked + Save disabled → skip save, sirf navigate (DIVASI/FACTO/DISASI/HQ sab)
      if (isNextBlockAlreadyAccessible && (buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag)) {
         navigate("/BlockJ");
         return;
      }

      // Only call getFormASII1Field once and proceed only if it returns true
      if (getFormASII1Field() !== true) {
        return false;
      }
      // DIVASI + statusFlag=1: do not save, just navigate
      if (isDivasiStatusFlagOne) {
         navigate("/BlockJ");
         return;
      }
      // HQADM/HQASI + statusFlag=3: do not save, just navigate
      if (isHqStatusFlagThree) {
         navigate("/BlockJ");
         return;
      }
      const confirmed = window.confirm("Have you saved your changes?");
      if (!confirmed) return;

      if (statusUnitCode === '5') {
         const saveResult = await handleSaveData("SAVE");
         if (saveResult) {
            blockValidation()
            navigate("/BlockJ")
         }
      } else {
         const saveResult = await handleSaveData("SAVE");
         if (saveResult) {
            blockValidation()
            navigate("/BlockJ")
         }
      }
   }

   // Helper to calculate Block I total (blockEfieldData + blockFfieldData + blockHfieldData + Block I SI No 11 Purchase Value)
   // Note: fetchASIFormECallback.formEItem14Value is excluded from calculation
   const calculateBlockITotal = () => {
      // Block E wages or salaries - use state value first, then prop as fallback
      // let totalE = blockEfieldDataState?.wagesOrSalaries || blockEfieldData?.wagesOrSalaries; old code
      let totalE = blockEfieldDataState?.wagesOrSalaries;
      if (totalE === undefined || totalE === null || totalE === '') totalE = 0;
      else totalE = parseFloat(totalE);
      
      console.log('calculateBlockITotal - Block E value:', totalE);
      
      // Block F expenditure
      let totalF = blockFfieldData?.expenditure;
      if (totalF === undefined || totalF === null || totalF === '') totalF = 0;
      else totalF = parseFloat(totalF);
      
      // Block H purchase value
      let totalH = blockHfieldData?.purchaseValue;
      if (totalH === undefined || totalH === null || totalH === '') totalH = 0;
      else totalH = parseFloat(totalH);
      
      // Block I SI No 11 (Total Imports) - Column 6 Purchase Value
      // Find row with itemCode '9994000' (Total Imports)
      let blockITotalImportsValue = 0;
      const itemDataArray = Object.values(itemData);
      const totalImportsRow = itemDataArray.find(item => item.itemCode === '9994000');
      if (totalImportsRow && totalImportsRow.purchaseValue) {
         blockITotalImportsValue = parseFloat(totalImportsRow.purchaseValue) || 0;
      }
      
      // Total = Block E + Block F + Block H + Block I SI No 11 Purchase Value
      const total = totalE + totalF + totalH + blockITotalImportsValue;
      console.log('calculateBlockITotal - Values:', {
         totalE: totalE,
         totalF: totalF,
         totalH: totalH,
         blockITotalImportsValue: blockITotalImportsValue,
         total: total,
         note: 'fetchASIFormECallback.formEItem14Value is excluded'
      });
      return total;
   }

            const getFormASII1Field = () => {
            console.log('getFormASII1Field called');
            
            // Context se data lo, agar nahi mila to prop se lo
            let formEItem14Value = initialData !== null ? initialData : blockEfieldData.wagesOrSalaries;
      if (formEItem14Value === undefined || formEItem14Value === null || formEItem14Value === '') {
         formEItem14Value = 0;
      } else {
         formEItem14Value = parseFloat(formEItem14Value);
      }
      let totalValue = calculateBlockITotal();
      console.log("formEItem14Value", formEItem14Value);
      console.log("totalValue", totalValue);
      // let diff = totalValue > formEItem14Value ? formEItem14Value - totalValue:Math.abs(formEItem14Value - totalValue) //old code
      const diff = Math.abs(formEItem14Value - totalValue);
      // if (diff < 0.01) { //old
         if (diff >= 0 && diff <= 0.01) {
         console.log('getFormASII1Field - Values match! Proceeding to next page.');
         return true;
      } else {
          let column = (blockInfo.surveyYear >= 2023) ? 15 : 14;
          const bool = window.confirm("Please check total mismatch with Item " + column + " in col 8 of Block E" +
            "\nEntered value in Block E Item " + column + " is " + formEItem14Value +
            "\nPlease Enter this values in Block E Item " + column + " :" + totalValue + "\n\nDo you want to go Block E?");
          if (bool == true) {
            navigate("/BlockE");
          } else {
            return false;
         }
      }
   }

   //All block validation Data
   const blockValidation = async () => {
      let postData = {
         dsl_no: blockInfo.dslNo,
         survey_year: blockInfo.surveyYear
      }

      try {
         showAppLoading(true);
         const response = await axios.post(`${API_URL}api/asi/blockValidation`, postData, config);
         const { data, status } = response.data;
         const accessIds = data.allblockData
         if (accessIds.length > 0) {

            if (accessIds.length > [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].length) {
               accessAsiBlock(accessIds)
            } else {
               accessAsiBlock([1, 2, 3, 4, 5, 6, 7, 8, 9, 10])
            }

         } else {
            accessAsiBlock([1, 2, 3, 4, 5, 6, 7, 8, 9, 10])
         }
         showAppLoading(false);
         return true;

      } catch (error) {
         console.error(error);
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {

      }
   }

   /* get item code detail */
   const handleOnBlur = async (IndexId, newValue) => {
      // Check if value has actually changed
      const originalValue = originalValues[IndexId] || '';
      
      console.log('handleOnBlur - IndexId:', IndexId, 'Original Value:', originalValue, 'New Value:', newValue);
      
      // If value hasn't changed, don't make API call
      if (originalValue === newValue) {
         console.log('Value unchanged, skipping API call for IndexId:', IndexId);
         // Clear the original value tracking for this field
         setOriginalValues(prev => {
            const newState = { ...prev };
            delete newState[IndexId];
            return newState;
         });
         return false;
      }

      let newItemAdded = {
         "id": IndexId,
         "dslNo": blockInfo.dslNo,
         "surveyYear": blockInfo.surveyYear,
         "itemCode": "",
         "itemDesc": "",
         "purchaseValue": "",
         "qtyConsumed": "",
         "ratePerUnit": "",
         "unitOfQty": "",
         "itemCodeClass": "textBox_back_color_white",
      };

      if (newValue === '') {
         newItemAdded.itemCode = "";
         handleTableRowData(IndexId, newItemAdded)
         // Clear original value tracking
         setOriginalValues(prev => {
            const newState = { ...prev };
            delete newState[IndexId];
            return newState;
         });
         return false;
      }
      const asicc_code = newValue
      const newObject = {
         asicc_code: asicc_code,
         "page_type": "BlockI"

      };

      if (asicc_code.length < 7) {
         newItemAdded.itemCode = "";
         handleTableRowData(IndexId, newItemAdded)
         toast.error("Invalid NPCMS Code.", messages.COLOR_RED);
         // Clear original value tracking
         setOriginalValues(prev => {
            const newState = { ...prev };
            delete newState[IndexId];
            return newState;
         });
         return false;
      }

      showAppLoading(true);

      try {
         const response = await axios.post(`${API_URL}api/asi/blockHFetchDataByItemCodeNPCMS`, newObject, config);
         const { status, message, data } = response.data;

         if (status) {
            const response = data.blockHData;
            newItemAdded.itemDesc = response.itemDesc
            newItemAdded.itemCode = asicc_code
            newItemAdded.unitOfQty = response.unitOfQty
            newItemAdded.itemCodeClass = "textBox_back_color_white"

         } else {
            toast.error('Item not present - Please check itemcode', messages.COLOR_RED);
         }

         handleTableRowData(IndexId, newItemAdded)
      } catch (error) {
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {
         showAppLoading(false);
         // Clear original value tracking in all exit points (success, error, early return)
         setOriginalValues(prev => {
            const newState = { ...prev };
            delete newState[IndexId];
            return newState;
         });
      }
   }

   const handleTableRowData = (IndexId, newItemAdded) => {
      setItemData(prevItemData => ({
         ...prevItemData,
         [IndexId]: {
            ...prevItemData[IndexId],
            ...newItemAdded
         }
      }));
      return true;
   }

   /* onchange form data code start here */
   const handleOnChange = (IndexId, field, newValue) => {
      if (!isNumeric(newValue)) {
         toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
         newValue = '';
      }

      // Track original value for itemCode field when user first starts typing
      if (field === 'itemCode' && !originalValues[IndexId]) {
         const currentValue = itemData[IndexId] ? itemData[IndexId].itemCode : '';
         setOriginalValues(prev => ({
            ...prev,
            [IndexId]: currentValue
         }));
      }

      setItemData(prevItemData => {
         const updatedItemData = {
            ...prevItemData,
            [IndexId]: {
               ...prevItemData[IndexId],
               [field]: newValue
            }
         };

         // Auto-calculate Rate per Unit when Quantity Consumed or Purchase Value changes
         // Only calculate if Rate per Unit field is not disabled for this itemCode
         const disabledItemCodes = ['9922100', '9994000'];
         const isRatePerUnitDisabled = disabledItemCodes.includes(updatedItemData[IndexId]?.itemCode);
         
         if ((field === 'qtyConsumed' || field === 'purchaseValue') && !isRatePerUnitDisabled) {
            const qtyConsumed = field === 'qtyConsumed' ? newValue : (updatedItemData[IndexId]?.qtyConsumed || '');
            const purchaseValue = field === 'purchaseValue' ? newValue : (updatedItemData[IndexId]?.purchaseValue || '');
            
            // Check if both values are valid numbers and greater than 0
            const qtyNum = parseFloat(qtyConsumed);
            const purchaseNum = parseFloat(purchaseValue);
            
            if (!isNaN(qtyNum) && !isNaN(purchaseNum) && qtyNum > 0 && purchaseNum > 0) {
               const calculatedRate = purchaseNum / qtyNum;
               // Round to 2 decimal places
               updatedItemData[IndexId].ratePerUnit = calculatedRate.toFixed(2);
            } else {
               // If either value is empty or invalid, clear rate per unit
               updatedItemData[IndexId].ratePerUnit = '';
            }
         }

         return updatedItemData;
      });
   }
   /* onchange form data code end here */

   // Function to handle focus event - store original value when user first focuses on itemCode field
   const handleOnFocus = (IndexId, field) => {
      if (field === 'itemCode' && !originalValues[IndexId]) {
         const currentValue = itemData[IndexId] ? itemData[IndexId].itemCode : '';
         console.log('Storing original value for IndexId:', IndexId, 'Value:', currentValue);
         setOriginalValues(prev => ({
            ...prev,
            [IndexId]: currentValue
         }));
      }
   }

   // Function to handle Added one row on button click
   const addRow = () => {
      let newCustomObject = [];
      for (let i = 0; i < 1; i++) {
         const newItemAdded = {
            "dslNo": blockInfo.dslNo,
            "surveyYear": blockInfo.surveyYear,
            "itemCode": '',
            "unitOfQty": '',
            "qtyConsumed": '',
            "purchaseValue": '',
            "ratePerUnit": '',
            "itemDesc": '',
            "statusFlag": '',
            "itemCodeClass": "textBox_back_color_white",
         }
         newCustomObject.push(newItemAdded);
      }
      const dataArray = Object.values(itemData);
      const AddedIndex = dataArray.length - 3
      dataArray.splice(AddedIndex, 0, ...newCustomObject);
      const stratIndex = 23
      customObjectObjectData(dataArray, stratIndex)
   };

   // Item codes for which Rate per Unit is not auto-calculated (same as in handleOnChange)
   const RATE_PER_UNIT_DISABLED_ITEM_CODES = ['9922100', '9994000'];

   // Function to handle update state according to data
   // When API returns only qtyConsumed & purchaseValue (no ratePerUnit), auto-calculate ratePerUnit for display
   const customObjectObjectData = (responseBlockHData, stratIndex) => {
      const initialData = {};
      responseBlockHData.forEach((item, index) => {
         let ratePerUnit = item.ratePerUnit;
         const hasRate = ratePerUnit !== undefined && ratePerUnit !== null && String(ratePerUnit).trim() !== '';
         const qtyConsumed = item.qtyConsumed;
         const purchaseValue = item.purchaseValue;
         const qtyNum = parseFloat(qtyConsumed);
         const purchaseNum = parseFloat(purchaseValue);
         const isRateDisabled = item.itemCode && RATE_PER_UNIT_DISABLED_ITEM_CODES.includes(String(item.itemCode).trim());
         if (!hasRate && !isRateDisabled && !isNaN(qtyNum) && !isNaN(purchaseNum) && qtyNum > 0 && purchaseNum > 0) {
            ratePerUnit = (purchaseNum / qtyNum).toFixed(2);
         }
         initialData[index] = {
            id: index,
            dslNo: blockInfo.dslNo,
            surveyYear: blockInfo.surveyYear,
            itemCode: item.itemCode,
            itemDesc: item.itemDesc,
            purchaseValue: item.purchaseValue,
            qtyConsumed: item.qtyConsumed,
            ratePerUnit: ratePerUnit ?? item.ratePerUnit ?? '',
            unitOfQty: item.unitOfQty,
         };
      });

      setItemData(initialData);
   }

   // Function to handle the store chckbox checked data 
   const handleCheckboxChange = (event, index) => {
      if (event.target.checked) {
         setCheckedItems([...checkedItems, index]);
      } else {
         setCheckedItems(checkedItems.filter((item) => item !== index));
      }
   };

   // Function to handle delete row
   const DeleteRow = () => {
      const dataArray = Object.values(itemData);

      if (checkedItems.length === 0) {
         toast.error('Please select at least one row for deletion.', messages.COLOR_RED);
         return false;
      }

      const updatedItems = dataArray.filter((_, index) => !checkedItems.includes(index));
      customObjectObjectData(updatedItems, '')
      setCheckedItems([]);
   };

   // Function to handle update and save form data
   const handleSaveData = async (buttonType) => {
      // Proceed with validation and save (Block E vs Block I validation only on Next button)
      if (statusUnitCode !== '5' && !valForBlockI()) {
         return false;
      }
      let allObjectData = itemData;

      let customItemCodes = [];
      const clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel);

      for (let id in allObjectData) {
         if (allObjectData[id].itemCode) {
            const customObject = {
               dslNo: allObjectData[id].dslNo,
               surveyYear: allObjectData[id].surveyYear,
               itemCode: allObjectData[id].itemCode,
               itemDesc: allObjectData[id].itemDesc,
               purchaseValue: handleValue(allObjectData[id].purchaseValue),
               qtyConsumed: handleValue(allObjectData[id].qtyConsumed),
               ratePerUnit: handleValue(allObjectData[id].ratePerUnit),
               unitOfQty: handleValue(allObjectData[id].unitOfQty),
               statusFlag: clickButtonStatusFlag
            };
            customItemCodes.push(customObject);
         }
      }

      const newObject = {
         itemCodes: customItemCodes,
         payload: {
            dsl_no: blockInfo.dslNo,
            survey_year: blockInfo.surveyYear,
            buttonType: buttonType
         }
      }

      showAppLoading(true);

      try {
         const response = await axios.post(`${API_URL}api/asi/blockIFormSaveToDB`, newObject, config);
         const { status, message } = response.data;
         if (status) {
            blockValidation()
            toast.success(message, messages.COLOR_RED);
            return true;
         }
      } catch (error) {
         console.error(error);
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {
         showAppLoading(false);
      }
      return false;
   }

   // Helper to save and go to next block
   const saveAndGoNext = async (buttonType) => {
      let allObjectData = itemData;
      let customItemCodes = [];
      const clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel);
      for (let id in allObjectData) {
         if (allObjectData[id].itemCode) {
            const customObject = {
               dslNo: allObjectData[id].dslNo,
               surveyYear: allObjectData[id].surveyYear,
               itemCode: allObjectData[id].itemCode,
               itemDesc: allObjectData[id].itemDesc,
               purchaseValue: handleValue(allObjectData[id].purchaseValue),
               qtyConsumed: handleValue(allObjectData[id].qtyConsumed),
               ratePerUnit: handleValue(allObjectData[id].ratePerUnit),
               unitOfQty: handleValue(allObjectData[id].unitOfQty),
               statusFlag: clickButtonStatusFlag
            };
            customItemCodes.push(customObject);
         }
      }
      const newObject = {
         itemCodes: customItemCodes,
         payload: {
            dsl_no: blockInfo.dslNo,
            survey_year: blockInfo.surveyYear,
            buttonType: buttonType
         }
      };
      showAppLoading(true);
      try {
         const response = await axios.post(`${API_URL}api/asi/blockIFormSaveToDB`, newObject, config);
         const { status, message } = response.data;
         if (status) {
            blockValidation();
            toast.success(message, messages.COLOR_RED);
            // Go to next block
            navigate('/BlockJ');
            return true;
         }
      } catch (error) {
         console.error(error);
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {
         showAppLoading(false);
      }
      return false;
   }

   const valForBlockI = () => {
      let comp = 0 //For IE 5+

      let allObjectData = itemData
      let dtable = itableRef.current;
      let rowCount = dtable.rows.length;
      let softResult = "";
      let checkFlag = "";
      const statusUnitCode = localStorage.getItem('statusUnitCode');
      const surveyYear = blockInfo.surveyYear;
      var pur = 0;
      let result = "";
      let arval = ["Quantity Consumed", "Purchase Value(in Rs)", "Rate Per Unit(in Rs)"];

      for (var i = 2; i < rowCount; i++) {
         const row = dtable.rows[i];

         for (let j = 4; j < 7; j++) {
            let node = row.cells[j].childNodes[0];
            if (j > 3 && node.value !== "" && node.value !== null) {
               let node = null;
               let node2 = null;
               try {
                  node = row.cells[j].childNodes[comp];
                  node2 = row.cells[2].childNodes[comp].value;
               } catch (ex) {
                  node = row.cells[j].childNodes[0];
                  node2 = row.cells[2].childNodes[0].value;
               }

               if (j > 3 && node.value !== "" && node.value != null && parseFloat(node.value) > 0) {
                  if (node2 === "")
                     result = result + "Sl no - " + (i - 1) + " should contain ITEM CODE  \n";
                  if (node.value.length > 15 && j !== 5)
                     result = result + "" + arval[(j - 4)] + " - " + (i - 1) + " should be less than 15 digits \n";
                  if (node.value.length > 12 && j === 5)
                     result = result + "" + arval[(j - 4)] + " - " + (i - 1) + " should be less than 12 digits\n";
                  if (isNaN(node.value))
                     result = result + "" + arval[(j - 4)] + " - " + (i - 1) + "should be a number   \n";
               }

               if (j === 5) {
                  var valll = null;
                  try {
                     valll = row.cells[5].childNodes[comp].value;
                  } catch (ex) {
                     valll = row.cells[5].childNodes[0].value;
                  }
                  if (node2 === "9994000") {
                     var val1 = parseInt(pur);
                     var val2 = null;
                     var val22 = null;
                     try {
                        val2 = parseInt(row.cells[5].childNodes[comp].value);
                        val22 = row.cells[5].childNodes[comp].value;
                     } catch (ex) {
                        val2 = parseInt(row.cells[5].childNodes[0].value);
                        val22 = row.cells[5].childNodes[0].value;
                     }

                     if (val1 !== val2 && val22 !== "") {
                        result = result + "Total imports - Please check total value\n";
                        row.cells[5].style.backgroundColor = '#FF0000';
                     } else {
                        row.cells[5].style.backgroundColor = '#FFFFFF';
                     }
                  } else if (valll !== "")
                     pur = parseInt(pur) + parseInt(valll);
               }

               var yearArray = ["2017", "2018", "2019", "2020", "2021"];
               if ((yearArray.includes(surveyYear)) &&
                  (!(statusUnitCode === '4' ||
                     statusUnitCode === '5' ||
                     statusUnitCode === '7' || statusUnitCode === '8'
                  ))) {

                  if (i < 6 && j === 5 && node.value !== "" && parseInt(node.value) > 0 &&
                     (row.cells[j - 1].childNodes[0].value === "" || parseInt(row.cells[j - 1].childNodes[0].value) === 0)) {
                     result = result + "" + arval[0] + " or " + arval[1] + " - " + (i - 1) + " of the input item is zero \n";
                  }

                  if (i < 6 && j == 4 && node.value !== "" && parseInt(node.value) > 0 &&
                     (row.cells[j + 1].childNodes[0].value === "" ||
                        parseInt(row.cells[j + 1].childNodes[0].value) === 0)) {
                     result = result + "" + arval[0] + " or " + arval[1] + " - " + (i - 1) + " of the input item is zero \n";
                  }

                  if (i === 7 && j === 5 && node.value !== "" && parseInt(node.value) > 0) {
                     let nextrow = dtable.rows[i + 1];
                     let nextnodeVal = nextrow.cells[j].childNodes[0].value;
                     if (nextnodeVal !== "" && parseInt(nextnodeVal) > 0) {
                        if (parseInt(node.value) > (0.15 * parseInt(nextnodeVal))) {
                           softResult = softResult + "" + "Other imported items is proportionately high: Block I, Col. 6, item 6 \n";
                        }
                     } else {
                        softResult = softResult + "" + "Other imported items is proportionately high: Block I, Col. 6, item 6 \n";
                     }
                  }

                  if (i < 7 && j === 5 && node.value !== "" && parseInt(node.value) > 0 && row.cells[j - 1].childNodes[0].value != "" && parseInt(row.cells[j - 1].childNodes[0].value) > 0) {
                     var val = parseInt(node.value) / parseInt(row.cells[j - 1].childNodes[0].value);
                     if (parseInt(node.value) < parseInt(row.cells[j - 1].childNodes[0].value)) {
                        result = result + "" + arval[0] + " - " + (i - 1) + " is equal or greater than " + arval[1] + " \n";
                     }
                  }

                  if (((i < (rowCount - 2))) && j === 6) {
                     if ((row.cells[j - 2].childNodes[0].value !== "" && parseFloat(row.cells[j - 2].childNodes[0].value) !== 0) && (row.cells[j - 1].childNodes[0].value !== "" && parseFloat(row.cells[j - 1].childNodes[0].value) !== 0)) {
                        if ((row.cells[j].childNodes[0].value === undefined || row.cells[j].childNodes[0].value === "" || parseFloat(row.cells[j].childNodes[0].value) === 0)) {
                           result = result + "" + arval[2] + " - " + (i - 1) + "  of the input item is zero \n";
                           row.cells[j].style.backgroundColor = '#FF0000';
                        } else {
                           row.cells[j].style.backgroundColor = '#FFFFFF';
                        }
                     }
                  }
               }
            }
         }
      }

      //code for item description validation
      if (checkFlag === 0) {
      } else if (checkFlag === 1 || checkFlag === '1') {
         alert("Enter item Description.");
         checkFlag = 0;
         return false;
      }

      if (softResult !== "" && result === "") {
         softResult = softResult + " \nFor change any Values Click OK."
         var clicked = window.confirm(softResult);
         softResult = "";
         if (clicked) {
            return false;
         }
      }
      if (result !== "") {
         alert(softResult + " \n " + result);
         return false;
      }
      return true;
   }

   const handleValue = (value) => {
      return (value !== "" && value !== null && value !== undefined) ? value : 0;
   };

   const storedLanguage = localStorage.getItem('language');

   return (
      <div className="card-body">
         {/* <ToastContainer /> */}
         <h4 className="page_heading border-bottom-0">
            <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.BLOCK_I_TITLE : asiTitle.en.BLOCK_I_TITLE }} />
         </h4>
         <div className="row">
            <div className="col-12">
               <h6 className="fw-semibold">
                  {storedLanguage === 'hi' ? asiTitle.hi.DSL_NO : asiTitle.en.DSL_NO}: <span className="fw-normal me-5">{blockInfo.dslNo}</span>
                  {storedLanguage === 'hi' ? asiTitle.hi.SERVEY_YEAR : asiTitle.en.SERVEY_YEAR}: <span className="fw-normal">{yearRange}</span>
               </h6>
               <div className="table-responsive  asi_block_table">
                  <table cellPadding="0" cellSpacing="0" id="velblocki" className="table table-bordered block_c_table" ref={itableRef}>
                     <thead className='text-center'>
                        <tr>
                           <th>{storedLanguage === 'hi' ? asiTitle.hi.SL_NO : asiTitle.en.SL_NO}</th>
                           <th>{storedLanguage === 'hi' ? asiTitle.hi.ITEM_DESCRIPTION_BLOCK_I : asiTitle.en.ITEM_DESCRIPTION_BLOCK_I}</th>
                           <th>{storedLanguage === 'hi' ? asiTitle.hi.ITEM_CODE : asiTitle.en.ITEM_CODE}</th>
                           <th>{storedLanguage === 'hi' ? asiTitle.hi.UNIT_OF_QUANTITY : asiTitle.en.UNIT_OF_QUANTITY}</th>
                           <th>{storedLanguage === 'hi' ? asiTitle.hi.QUANTITY_CONSUMED : asiTitle.en.QUANTITY_CONSUMED}</th>
                           <th>{storedLanguage === 'hi' ? asiTitle.hi.PURCHASE_VALUE : asiTitle.en.PURCHASE_VALUE}</th>
                           <th>{storedLanguage === 'hi' ? asiTitle.hi.RATE_PER_UNIT : asiTitle.en.RATE_PER_UNIT}</th>
                        </tr>
                        <tr>
                           <th>1</th>
                           <th>2</th>
                           <th>3</th>
                           <th>4</th>
                           <th>5</th>
                           <th>6</th>
                           <th>7</th>
                        </tr>
                     </thead>
                     <tbody>
                        {
                           Object.values(itemData).map((item, i) => {
                              let isDisable = false;
                              if (itemCodeArray.includes(itemData[item.id].itemCode) &&
                                 i >= Object.values(itemData).length - 2) {
                                 isDisable = true
                              }
                              return (
                                 <tr key={i}>
                                    <td>{++srNo}
                                       {[0, 1, 2, 3, 4].includes(i) &&
                                          <>
                                          </>
                                       }
                                    </td>
                                    <td>
                                       <input
                                          type="text"
                                          className={`form-control ${['9994000'].includes(itemData[item.id].itemCode) ? 'text-bold-inside-textbox' : ''}`}
                                          maxLength="18"
                                          id={`itemDesc${i}`}
                                          name={`itemDesc${i}`}
                                          value={`${itemData[item.id].itemDesc}`}
                                       />
                                    </td>
                                    <td className={`${itemData[item.id].itemCodeClass}`}>
                                       <input
                                          type="text"
                                          maxLength="7"
                                          className="form-control"
                                          id={`itemCode${i}`}
                                          name={`itemCode${i}`}
                                          disabled={isDisable}
                                          value={`${itemData[item.id].itemCode}`}
                                          onChange={e => handleOnChange(item.id, 'itemCode', e.target.value)}
                                          onFocus={e => handleOnFocus(item.id, 'itemCode')}
                                          onBlur={e => handleOnBlur(item.id, e.target.value)}
                                       />
                                    </td>
                                    <td>
                                       <input
                                          type="text"
                                          className="form-control"
                                          id={`unitOfQty${i}`}
                                          name={`unitOfQty${i}`}
                                          disabled={isDisable}
                                          maxLength="19"
                                          value={(['9922100', '9994000'].includes(itemData[item.id].itemCode) && (itemData[item.id].unitOfQty === '0' || itemData[item.id].unitOfQty === 0)) ? '' : (itemData[item.id].unitOfQty ?? '')}
                                       />
                                    </td>
                                    <td>
                                       <input
                                          type="text"
                                          className="form-control"
                                          id={`qtyConsumed${i}`}
                                          maxLength="18"
                                          name={`qtyConsumed${i}`}
                                          disabled={isDisable}
                                          value={(['9922100'].includes(itemData[item.id].itemCode) && (itemData[item.id].qtyConsumed === '0' || itemData[item.id].qtyConsumed === 0)) ? '' : (itemData[item.id].qtyConsumed ?? '')}
                                          // value={`${itemData[item.id].qtyConsumed}`}
                                          onChange={e => handleOnChange(item.id, 'qtyConsumed', e.target.value)}
                                       />
                                    </td>
                                    <td>
                                       <input
                                          type="text"
                                          className="form-control"
                                          id={`purchaseValue${i}`}
                                          maxLength="12"
                                          name={`purchaseValue${i}`}
                                          value={`${itemData[item.id].purchaseValue}`}
                                          onChange={e => handleOnChange(item.id, 'purchaseValue', e.target.value)}
                                       />
                                    </td>
                                    <td>
                                       <input
                                          type="text"
                                          className="form-control"
                                          id={`ratePerUnit${i}`}
                                          maxLength="18"
                                          name={`ratePerUnit${i}`}
                                          disabled={isDisable}
                                          value={(['9922100', '9994000'].includes(itemData[item.id].itemCode) && (itemData[item.id].ratePerUnit === '0' || itemData[item.id].ratePerUnit === 0)) ? '' : (itemData[item.id].ratePerUnit ?? '')}
                                          // value={`${itemData[item.id].ratePerUnit}`}
                                          onChange={e => handleOnChange(item.id, 'ratePerUnit', e.target.value)}
                                       />
                                    </td>
                                 </tr>
                              )
                           })}
                     </tbody>
                  </table>
               </div>
            </div>
         </div>

         <div className="row">
            <div className="col-12">
               <hr />
            </div>
            <div className="col-lg-8 text-center text-lg-start mb-3 mb-lg-0">
               <button
                  type="submit"
                  className="btn btn_orange me-1"
                  onClick={() => { window.print() }}
               >Print
                  <i className="fa fa-print ms-1"></i>
               </button>

               <button
                  type="button"
                  className="btn btn_orange me-1"
                  onClick={() => handleSaveData("SAVE")}
                  disabled={buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag}
               >
                  Save
               </button>

               <button
                  type="reset"
                  className="btn btn_orange me-1"
                  onClick={handleReset}
               >
                  Reset
               </button>

               <button
                  type="button"
                  className="btn btn_orange me-1"
                  onClick={(e) => (navigate("/dashboard"))}
               >
                  Cancel
               </button>

               <button
                  type="button"
                  className="btn btn-success me-1 px-3"
                  onClick={addRow}>
                  <i className="fa fa-plus-circle me-1"></i>
                  Add Row
               </button>

            </div>
            <div className="col-lg-4 text-center text-lg-end">
               <button
                  onClick={handlePrevious}
                  type="button"
                  className="btn btn_orange mx-1"
               >
                  <i className="fa fa-angle-left me-1"></i>
                  Previous
               </button>
               <button
                  onClick={handleNext}
                  type="button"
                  className="btn btn_orange mx-1"
                  disabled={isNextBlockAlreadyAccessible ? false : (isRestrictedRoleWithEmptyStatusFlag ? true : ((isDivasiStatusFlagOne || isHqStatusFlagThree) ? false : buttonStatus))}
               >
                  Next
                  <i className="fa fa-angle-right ms-1"></i>
               </button>
            </div>
         </div>
      </div>
   )
}

